export const API_URL = {
    PING: 'Ping',
    GETALLACTIVITIES: 'MasterActivity/GetMasterList',
    GETACTIVITYBYID: 'MasterActivity/GetActivity',
    ADDACTIVITY: 'MasterActivity/AddActivity',
    UPDATEACTIVITY: 'MasterActivity/UpdateActivity',
    DELETEACTIVITY: 'MasterActivity/DeleteActivity',
    DOWNLOAD_TIME_SURVEY_DOCUMENT: 'Survey/DownloadTimeSurveyDocument',
    DOWNLOAD_EXPENSE_SURVEY_DOCUMENT: 'ExpenseDocument/DownloadExpenseSurveyDocument',
    DELETE_TIME_SURVEY_DOCUMENT: 'Survey/DeleteTimeSurveyDocument',
    GET_EXPENSE_DATA_DETAILS: 'ExpenseData/GetExpenseDataDetails',
    GET_EXPENSE_DATA_FILE_COLUMN_VALUES: 'ExpenseSurvey/GetExpenseDataFileValues',
    CHECK_EXPENSE_SURVEY_UPDATE: 'ExpenseSurvey/CheckExpenseSurveyUpdate',
    UPDATE_EXPENSE_DATA_DETAILS: 'ExpenseData/UpdateExpenseDataDetails',
    DOWNLOAD_ERROR_FILE: 'File/DownloadErrorFile',
    DELETE_USERS: 'User/DeleteUsers',
    DELETE_USERS_FROM_AD: 'User/DeleteUsersFromAD',
    GET_CLIENT_SME_USERS: 'Client/GetClientSmeUsers',
    GET_CLIENT_USERS_STATUS: 'Client/GetClientUsersStatus',
    GET_FILE_IMPORT_STATUS: 'File/GetFileImportStatus',
    GETLOCATIONS:'Location/GetLocation',
    //COMMENTS
    GETCOMMENTS: 'Comments/GetComments',
    ADDCOMMMENTS: 'Comments/AddComment',
    //DOCUMENTS
    GETDOCUMENTS: 'Document/GetDocuments',
    MAPPROJECTDOCUMENTS: 'Document/MapProjDoc',
    GETSURVEYSONLYBYENGAGEMENTID : 'Document/GetSurveysOnlyByEngagementId',
    //EMPLOYEE
    ADDEMPLOYEE: 'Employee/AddEmployee',
    UPDATEEMPLOYEE: 'Employee/UpdateEmployee',
    DELETEEMPLOYEE: 'Employee/DeleteEmployees',
    GETEMPLOYEESBYENGAGEMENT: 'Employee/GetEmployees',
    GENERATEEMPLOYEEDATAFILE: 'Employee/DownloadEmployeeDetails',
    GETALLASSIGNEDEMPLOYEES: 'Employee/GetEmployees',
    ADDSPREADEMPLOYEES: 'Employee/UpdateSpreadEmployee',
    
    //CLIENT
    CLIENT: {
        ADD_UPDATE_ROLE: 'Client/AddUpdateRole',
        ADD_USER: 'Client/AddUser',
        ADD_USER_CHAMPION_ADMIN: 'Client/AddUserChampionAdmin',
        BULK_USER_PROVISION: 'Client/BulkUserProvision',
        CHECK_EMAIL: 'Client/CheckEmail',
        CHECK_SIGN_IN_NAME: 'Client/CheckSignInName',
        CREATE_ADHOC_EMPLOYEES: 'GenerateSurvey/CreateAdhocGroup',
        DELETE_EMAIL: 'Client/SendRequestForDeleting',
        DELETE_USER: 'Client/DeleteUser',
        GET_BY_USER: 'Client/GetAllClientsByUserId',
        GET_ALL_USER: 'Client/GetAllUser',
        GET_RCS_WATSON_DATA: 'Client/GetRCSWatsonDocumentAnalysis',
        GET_RCS_CONTRACT_DATA: 'Client/GetRCSContractDocumentAnalysis',
        GET_USER_FOR_HELP_EMAIL: 'Client/GetUserForHelpEmail',
        PROVISION_FAILED_USERS: 'Client/ProvisionFailedUsers',
        UPDATE_LOGIN_AS_CLIENT: 'Client/UpdateLoginAsClient',
        UPDATE_NICKNAME: 'Client/UpdateNickName',
        UPDATE_USER: 'Client/UpdateUser',
        UPDATE_USER_MODE: 'Client/UpdateUserMode',
        UPDATE_USER_NOTIFIED_DETAIL: 'Client/UpdateUserNotification',
        GET_USER_NOTIFIED_DETAIL: 'Client/GetUserNotifiedDetail',        
        UPDATE_RELEASE_STATUS: 'Client/UpdateReleaseDetail',
    },

    //Expense Data
    EXPENSEDATA: {
        GETEXPENSEDATABYENGAGEMENTID: 'ExpenseData/GetExpenseDataByEngagementId',
        GETEXPENSEDATACOLUMNNAMESBYENGAGEMENTID:
            'ExpenseData/getExpenseDataColumnNamesByEngagementId',
        DELETEEXPENSEDATA: 'ExpenseData/DeleteExpenseDataFile',
        UPLOADDATAFILE: 'ExpenseData/UploadDataFile',
        GETEXPENSEDATAFILE: 'ExpenseData/GetExpenseDataFiles',

    },
    //GET ENGAGEMENT
    ENGAGEMENT: {
        GET_BY_CLIENT_ID: 'Engagement/GetEngagementsByClientId',
        GETALLENGAGEMENTS: 'Engagement/GetAllEngagements',
        GETENGAGEMENTBYUSERID: 'Engagement/GetUserEngagements',
        GETENGAGEMENTBYID: 'Engagement/GetEngagement',
        CHECKENGAGMENTNUMBER: 'Engagement/CheckEngagementNumber',
        CHECKENGAGEMENTNAME: 'Engagement/CheckEngagementName',
        CREATENGAGEMENT: 'Engagement/SaveEngagement',
        EDITENGAGEMENT: 'Engagement/UpdateEngagement',
        DELETETAXPERIOD: 'Engagement/DeleteTaxPeriod',
        GETTAXPERIODS: 'Engagement/GetTaxPeriods',
        GET_TAX_PERIOD_QRE: 'Engagement/GetTaxPeriodQres',
        GETENGAGEMENTSBYCLIENTNAME: 'Engagement/GetEngagementsByClientName',
        GETDATAANALYSISSUMMARYDATA: 'Engagement/GetEngagementDataAnalysisSummary',
        GETENGAGEMENTBASIC: 'Engagement/GetEngagementBasic'
    },
    GETCLIENTNAMES: 'Engagement/GetClients',
    GETUSERSFORCLIENTADMIN: 'Client/GetClientByUserId',

    GETENGAGEMENTDATA: 'Engagement/GetEngagementDataAndStatusCount',
    GETENGAGEMENTACTIVITIES: 'Activity/GetActivities',
    ADDENGAGEMENTACTIVITY: 'Activity/AddActivity',
    UPDATEENGAGEMENTACTIVITY: 'Activity/UpdateActivity',
    SAVEENGAGEMENTACTIVITY: 'Activity/SaveEngagementActivity',
    DELETEENGAGEMENTACTIVITY: 'Activity/DeleteActivity',
    ACTIVITY: {
        DELETEBULKACTIVITY: 'Activity/DeleteBulkActivity',
    },
    UPLOADDATAFILE: 'File/UploadDataFile',
    GETUPLOADDATAFILE: 'File/GetDataFileList',
    DOWNLOADDATAFILE: 'File/DownloadDataFile',
    UPLOADFILE: 'File/UploadFile',
    GETINSTRUCTIONSFILE: 'File/GetInstructionsFile',
    ADDSURVEYTYPEGROUPINGMETHOD: 'GenerateSurvey/AddSurveyTypeGroupingMethod',
    GETSURVEYTYPEGROUPING: 'GenerateSurvey/GetSurveyTypeGroupingMethod',
    //INSIGHTS
    INSIGHTSGETQRE: 'Insights/GetQRE',
    INSIGHTSGETSURVEYMETRICS: 'Insights/GetSurveyMetrics',
    INSIGHTSGETOPPORTUNITIES: 'Insights/GetOpportunities',
    //INSIGHTSGETSURVEYS: 'Insights/GetSurveys',
    INSIGHTSGETSURVEYSFILTERED: 'Insights/GetSurveysFiltered',
    INSIGHTSSENDREMINDER: 'Insights/SendReminder',
    GETUNASSIGNEDSURVEYS: 'Insights/GetUnAssignedSurveys',
    BulkAssignSME: 'Insights/AssignBulkSurveys',
    ExportAllSurveys: 'Insights/DownloadAllSurveys',
    ExportSelectedSurveys: 'Insights/DownloadSelectedSurveys',
    //PROJECTS
    GETPROJECTS: 'Project/GetProjects',
    UPDATEPROJECTQUESTIONS: 'Project/UpdateProjectQuestions',
    GETPROJECTSANDQUESTIONS: 'Project/GetProjectAndQuestions',
    GETPROJECTSANDBUSINESSCOMPONENTS:'Project/GetProjectAndBusinessComponents',
    ADDPROJECT: 'Project/AddProject',
    UPDATECLIENTPROJECT: 'Project/UpdateClientProject',
    UPDATEPROJECT: 'Project/UpdateProject',
    DELETEPROJECT: 'Project/DeleteProject',
    GENERATEPROJECTDATAFILE: 'Project/GenerateProjectDataFile',
    DOWNLOADPROJECTS: 'Project/DownloadProjectsByEngagementId',
    GETPROJECTNAMES: 'Project/GetProjectNames',
    UPDATEBUSINESSCOMPDETAIL: 'Project/UpdateBusinessComponentDetail',
    UPDATEBUSINESSCOMPTAGGING: 'Project/UpdateBusinessComponentsTagging',
    DELETEBUSINESSCOMP: 'Project/DeleteBusinessComponent',
    ADDEXISTINGPROJECTTOBIZCOMP: 'Project/AddProjectToBusinessComponent',
    REMOVEPROJFROMBIZCOMP: 'Project/RemoveProjectFromBusinessComponent',
    GETLEGALENTITIESFORPROJECT:'Project/GetLegalEntityForProject',
    UPDATEBCQUALIFIEDPERCENTAGE: 'Project/UpdateBCQualifiedPercentage',
    UPDATECPQUALIFEIDPERCENTAGE: 'Project/UpdateCPQualifiedPercentage',
    //Project Survey
    CREATEPROJECTSURVEY: 'ProjectSurveyDetails/CreateNewSurveys',
    //Business Comp
    // GETBUSINESSCOMPNAMES: 'Project/GetBusinessCompNamesByEngagementId',
    //SURVEY
    GETSURVEYSBYRESPONDENT: 'Survey/GetSurveysByRespondent',
    GETSMESURVEYS: 'Survey/GetSurveysBySME',    
    UPDATESURVEYCELL: 'Survey/UpdateSurveyCell',
    UPDATESURVEYMETADATA: 'Survey/UpdateSurveyMetadata',
    ADDEMPLOYEEBYSURVEYRESPONDENT: 'Survey/AddEmployeeBySurveyRepondent',
    REMOVEMPLOYEEFROMSURVEY: 'Survey/RemoveEmployeeFromSurvey',
    SURVEY: {
        CHECKIFRECONCILEEXISTS: 'Reconciliation/CheckIfReconciliationExists',
        GETRECONCILESURVEYDETAILS: 'Survey/GetReconcileSurveyDetails',
        UPDATERECONCILESURVEYCELL: 'Survey/UpdateReconcileSurveyCell',
        UPDATEMULTIPLERECONCILESURVEYCELL: 'Survey/UpdateMultipleReconcileSurveyCell',
        ASSIGNSURVEYRESPONDENT: 'Survey/AssignSurveyRespondent',
        ASSIGNMULTIPLESMES: 'Survey/AssignMultipleSMEs',
        SENDEMAILASSIGNMULTIPLESMES: 'Survey/SendEmailAssignMultipleSMEs',
        GETSMESASSIGNEDTOSURVEY: 'Survey/GetSMEsAssignedToSurvey',
        CHECKSURVEYNAME: 'Survey/CheckSurveyNameExists',
        GETSURVEYSTATUS: 'Survey/GetSurveyStatus',
        UPDATGEMULTIPLESURVEY: 'Survey/UpdateMultipleSurveyCell',
        GETUNASSIGNEDPROJECTSACTIVITIES: 'Survey/GetUnAssignedProjectsActivities',
        GETSURVEYPROJECTSACTIVITIES: 'Survey/GetSurveyProjectsActivities',
        ADDSURVEYPROJECT: 'Survey/AddSurveyProject',
        ADDSURVEYACTIVITY: 'Survey/AddSurveyActivity',
        EDITSURVEYPROJECTACTIVITY: 'Survey/EditSurveyProjectActivity',
        GETSURVEYDETAILS: 'Survey/GetSurveyDetails?surveyId=',
        UPDATESURVEYCELL: 'Survey/UpdateSurveyCell',
        GETEMPLOYEESNOTINSURVEY: 'Survey/GetEmployeesnotinSurvey',
        ADDEMPLOYEETOSURVEY: 'Survey/AddEmployee',
        SUBMITSURVEY: 'Survey/SubmitSurvey',
        DELETESURVEY: 'Survey/DeleteSurvey',
        DELETEMULTIPLESURVEYS: 'Survey/DeleteMultipleSurveys',
        REMOVEEMPLOYEEFROMSURVEY: 'Survey/RemoveEmployeeFromSurvey',
        DOWNLOADSURVEYDETAILS: 'Survey/DownloadSurveyDetails',
        UPLOADSURVEYDETAILS: 'Survey/UploadSurveyDetails',
        GETSURVEYREASONHISTORY: 'Survey/GetSurveyReasonHistory',
        GET_GROUPING_FOR_EXPENSESURVEY: 'ExpenseSurvey/GetGroupingForExpenseSurvey',
        GET_SME_EMAIL_TEMPLATE: 'Survey/GetEmailTemplate',
        USE_AS_AUTOREMINDER: 'Survey/UseAsAutoReminderEmail',
        UPDATE_EMAIL_DEFAULT_CC: 'Survey/UpdateEmailDefaultCc',
        SEND_EMAIL_TOSME: 'Survey/SendEmailToSME',
        GET_SME_EMAIL_SENT_BY_SURVEY_IDS: 'Survey/GetSmesEmailSentDetailsBySurveyIds',
        GET_SME_EMAIL_SENT_DETAILS: 'Survey/GetSMEsEmailSentDetailsToSurvey',
        SAVE_CUSTOM_EMAIL_TEMPLATE: 'Survey/SaveCustomEmailTemplate',
        GET_CUSTOM_EMAIL_TEMPLATE: 'Survey/GetCustomEmailTemplate',
        DELETE_CUSTOM_EMAIL_TEMPLATE: 'Survey/DeleteCustomEmailTemplate',
        GET_SURVEYS: 'Survey/TimeSurveyGetSurveys',
        MOVE_EMPLOYEES: 'Survey/TimeSurveyMoveEmployees',
        GETENGAGEMENTACTIVITIES: 'Survey/GetEngagementActivities',
        ADDENGPROJECTSUNDERSURVEYS: 'Survey/AddEngagementProjectsInSurveys',
        ADDENGAGEMENTACTIVITIESUNDERSURVEYS: 'Survey/AddBulkSelectedActivitiesInSurveys',
        UPDATEDUEDATEFORSELECTEDSURVEYS: 'Survey/BulkUpdateSelectedSurveysDueDates',
        UpdateSurveysToFullyAllocated: 'Survey/UpdateSurveysFullyAllocated',
        GetSurveysSMEDefaultEmailDetails :'Survey/GetSurveysSMEDefaultEmailDetails'
    },
    GETGROUPINGMETHODS: 'SurveyTypeGroupingMethod/GetGroupingMethods',
    GETPERMISSIONS: 'User/GetPermissions',
    UPDATEFIRSTLOGINDATETIME: 'User/UpdateFirstLoginDateTime',
    GETADUSERS: 'User/GetADUsers',
    EMPLOYEE: {
        GETEMPLOYEES: 'Employee/GetEmployees',
    },
    GENERETESURVEY: {
        GETSURVEYPREPLIST: 'GenerateSurvey/GetSurveyPrepList',
        GETACTIVITYLIST: 'GenerateSurvey/GetActivityList',
        GETPROJECTLIST: 'GenerateSurvey/GetProjectList',
        GENERATE_SURVEY: 'GenerateSurvey/GenerateSurvey',
        GET_EMPLOYESS_BY_GROUP: 'GenerateSurvey/GetEmployeesByGroup',
        GROUPRADIOBUTTONCHECK:
            'GenerateSurvey/checkProjectsAndActivitiesForSurveyType',
        ENABLESURVEYTYPEGROUPING: 'GenerateSurvey/SurveyTypeGroupEmployees',
    },
    MASTERACTIVITY: {
        GETMASTERLIST: 'MasterActivity/GetMasterList',
        ADDACTIVITY: 'MasterActivity/AddActivity',
        UPDATEACTIVITY: 'MasterActivity/UpdateActivity',
        DELETEACTIVITY: 'MasterActivity/DeleteActivity',
        GETMASTERACTIVITYGROUP: 'MasterActivity/GetMasterActivityGroup',
    },
    ACTIONLOGS: {
        GETACTIONLOGS:'ActionLogs/GetActionLogsByUsersClient'
    },
    //REVIEWS
    REVIEWS: {
        GET_JOBTITLESQRE: 'ReviewQNQ/GetJobTitlesQRE',
        GET_ADJUSTEDWAGEQRE: 'ReviewQNQ/GetAdjustedWageQRE',
        UPDATE_JOBTITLESQPERCENTAGE: 'ReviewQNQ/UpdateJobTitlesQPercentage'
    },
    //REPORTS
    REPORTS: {
        DOWNLOADREPORTS: 'Report/DownloadReports',
        DOWNLOADREPORTSASZIP: 'Report/DownloadReportsAsZip',
        DOWNLOADFILES:'Report/DownloadFiles',
        GET_RELEASE_FILE_UPLOAD_STATUS: 'Report/GetReleaseFileDetail',
        GETQREREPORTSLIST: 'Report/GetQREReportsList',
        GETFEDERALTEMPLATE: 'Report/DownloadFederalTemplate',
        LOAD_CREDIT_REPORT: 'Report/LoadCreditReport',
        SAVECREDITREPORT: 'Report/SaveCreditReport',
        UPLOAD_TO_DGDOCS: 'Report/UploadToDgDocs',
        GET_AGILE_ANALYZER_REVIEW_REPORT: 'AgileAnalyzer/GetWorkflowReportsList',
        DOWNLOAD_AGILE_ANALYZER_REPORT: 'AgileAnalyzer/DownloadTimeSurveyOutputFile',
        DOWNLOAD_WORKFLOW_OUTPUT_FILE: 'AgileAnalyzer/DownloadWorkflowOutputFile',
        DOWNLOAD_SAVED_SOURCE_FILE: 'AgileAnalyzer/DownloadSavedSourceFile',
        GETENGAGEMENTSBYCLIENT: 'Report/GetEngagementsByClient',
        DOWNLOAD_ADMINREPORT: 'Report/DownloadActivityReport',
        DOWNLOAD_LOOKUPREPORT: 'Report/DownloadLookUpReport',
        GET_LOOKUPREPORTNAMES: 'Report/GetLookUpReportNames',
    },

    //DOCUMENTS
    DOCUMENT: {
        DOWNLOADOCUMENTS: 'Document/DownloadDocument',
        GETEMPLOYEEDOCUMENTS: 'Document/GetEmployeeDocuments',
        DELETEDOCUMENTS: 'Document/DeleteDocument',
        DELETEENGAGEMENTDOCUMENTS: 'Document/DeleteEngagementDocument',
    },

    //COMMENTS
    COMMENTS: {
        GETRECONCILECOMMENTS: 'Comments/GetReconcileComments',
        RESOLVERECONCILECOMMENT: 'Comments/ResolveReconcileComment',
        GETCOMMENTS: 'Comments/GetComments',
        GETTOTALCOMMENTS: 'Comments/GetTotalComments',
        ADDCOMMENTS: 'Comments/AddComment',
        RESOLVECOMMENT: 'Comments/ResolveComment',
    },
    UPLOAD_CREDITR_EPORT_TEMPLATE: 'Report/UploadCreditReportTemplate',
    EXPENSESURVEY: {
        CREATE_EXPENSE_SURVEY: 'ExpenseSurvey/GenerateExpenseSurvey',
        DELETE_EXPENSE_SURVEY_MULTIPLE: 'ExpenseSurvey/DeleteExpenseSurveyMultiple',
        GET_UPLOADED_DETAILS_BY_ENGAGEMENT: 'ExpenseSurvey/GetUploadedFileDetailsByEngagementId',
        GETEXPENSESURVEYSDATABYENGAGEMENTID: 'ExpenseSurvey/GetExpenseSurveysDataByEngagementId',
        GETEXPENSESURVEYDROPDOWNDATA: 'ExpenseSurvey/GetExpenseSurveyDropDownData',
        EXPORTEXPENSESURVEYDATA: 'ExpenseSurvey/ExportExpenseSurveyData',
        UPDATESURVEYSDATABYENGAGEMENTID: 'ExpenseSurvey/UpdateSurveysDataByEngagementId',
        GETESURVEYDOCUMENTS: 'ExpenseDocument/GetExpenseSurveyDocuments',
        // GET_ESURVEY_RECORD_DOCUMENTS: 'ExpenseDocument/GetExpenseSurveyDetailDocuments',
        MAP_PROJECTS_QRETYPE_LOCATION: 'ExpenseSurvey/MapProjectsQRETypeLocation',
        GET_SURVEYSFILTERED: 'ExpenseSurvey/GetExpenseSurveyFiltered',
        DELETE_EXPENSESURVEY: 'ExpenseSurvey/DeleteExpenseSurveyeRecord',
        GETEXPENSESURVEYSDETAILDATA: 'ExpenseSurvey/GetExpenseSurveysExcelDetailData',
        SUBMIT_EXPENSESURVEY: 'ExpenseSurvey/SubmitExpenseSurvey',
        GETEXPENSESURVEYS_SUBMITREASONHISTORY: 'ExpenseSurvey/GetExpenseSurveyReasonHistory',
        UPDATEEXPENSESURVEYDETAILS: 'ExpenseSurvey/UpdateExpenseSurveyDetails',
        GETEXPENSESURVEYS_COMMENTS: 'ExpenseSurvey/GetExpenseSurveyComments',
        ADDEXPENSESURVEYS_COMMENTS: 'ExpenseSurvey/AddExpenseSurveyComments',
        GETEXPENSESURVEYSBASEDONGROUPING: 'ExpenseSurvey/GetExpenseSurveysBasedonGrouping',
        GENERATEMULTIPLEEXPENSESURVEY: 'ExpenseSurvey/GenerateMultipleExpenseSurvey',
        DELETEEXPENSESURVEYDOCUMENT: 'ExpenseDocument/DeleteExpenseSurveyDocument',
        GETEXPENSECLIENTUSERS: 'ExpenseSurvey/GetExpenseClientUsers',
        DOWNLOADEXPENSESURVEYS: 'ExpenseSurvey/DownloadExpenseSurveys',
        GET_EXPENSE_SME_EMAIL_SENT_DETAILS: 'ExpenseSurvey/GetExpenseSMEsEmailSentDetailsToSurvey',
        GetExpenseSurveysSMEDefaultEmailDetails :'ExpenseSurvey/GetExpenseSurveysSMEDefaultEmailDetails'
    },
    PROJECTSURVEY: {
        GET_SURVEYSFILTERED: 'ProjectSurvey/GetProjectSurveysFiltered',
    },
    GET_EXPENDITURE_DATA: 'ExpenditureType/GetStudyExpenditureTypes',
    UPDATE_HAIRCUT: 'ExpenditureType/UpdateStudyExpenditureTypes',
    GET_STUDY_SUMMARY: 'Insights/GetStudySummary',
    GET_IMPORT_FILE_STATUS: 'Insights/GetImportFileStatus',
    //TimeTracking
    TIMETRACKING: {
        GETUPLOADEDFILEDETAILS: 'TimeTracking/GetUploadedFilesDetailsByEngagementId',
        GETUPLOADEDFILEDETAILSSTATUS: 'TimeTracking/GetTimeTrackingStatusByEngagementId',
        BULKEDITPROJECT: 'TimeTracking/BulkEditProject',
        EXCEPTIONDETAILS: 'TimeTracking/GetTimeTrackingErrorDetailsByEngagementId',
        DELETETIMETRACKING: 'TimeTracking/DeleteTimeTrackingDataByEngagementId',
    },

    AGILEANALYZER: {
        GETALTERYXQUESTIONSANDSTATUS: 'AgileAnalyzer/GetAgileAnalyzerScreenStatus',
        UPLOADTEMPLATE: 'AgileAnalyzer/UploadAgileAnalyzerFile',
        DOWNLOADALTERYXQUESTIONTEMPLATE: 'AgileAnalyzer/DownloadAlteryxQuestionTemplate',
        ANALYZEDATA: 'AgileAnalyzer/ExecuteAgileAnalyzerWorkflow',
        DELETEALTERYXUPLOADEDTEMPLATE: 'AgileAnalyzer/DeleteAlteryxUploadedInputFile',
        GET_WORKFLOW_SAVED_FILE_LIST: 'AgileAnalyzer/GetWorkflowSavedSourceFilesList',
        GETWORKFLOWEXECUTIONSTATUS: 'AgileAnalyzer/GetAgileAnalyzerWorkflowExecutionStatus',
        STARTOVER: 'AgileAnalyzer/ExecuteStartOver'
    },

    //DASHBOARD
    DASHBOARD: {
        REPORTCONFIG_GET_BYCLIENTID: 'PowerBI/GetEmbedReportByClientID',
        SCHEDULEDREFRESHMSG_GET: 'PowerBI/GetScheduledRefreshTimeMessage',
        REPORT_TOKEN_GET_BYCLIENTID: 'PowerBI/GetReportToken',
        REPORTCONFIG_GET: 'PowerBI/GetEmbedReport',
        REPORT_TOKEN_GET: 'PowerBI/GetEmbedReportToken'
    },

    ISCLIENTROLE_EXISTS: 'Client/isClientRoleExists',

    //EXPENSE-SINGLE-SURVEY
    GETCOMPANIESANDCOSTCENTER: 'ExpenseSurvey/GetCompanyCostCenterLookup',

    // BENCHMARK
    IS_SUPER_ADMIN: 'Admin/IsSuperAdmin',
    GET_BENCHMARK_DATA: "Benchmark/GetBenchmarkDataByCountryCode",
    BENCHMARK_CALCULATE: "Benchmark/BenchmarkCalculate",

    //Page Feedback
    PAGEFEEDBACK: {
        GETPAGEFEEDBACKS: "PageFeedback/GetPageFeedbacks",
        INSERTPAGEFEEDBACK: "PageFeedback/InsertPageFeedback"
    },
    GET_PROJECT_SURVEY_QUESTION_ANSWER: 'ProjectSurveyDetails/GetProjectSurveyQuestionAnswer',
    SUBMIT_PROJECT_SURVEY: 'ProjectSurveyDetails/SubmitProjectSurvey',
    //project survey detail
    PROJECTSURVEYDETAILS: {
        GET_PROJECTSURVEYDETAILS_QUESTIONANSWER: 'ProjectSurveyDetails/GetProjectSurveyDetails',
        ADDUPDATE_PROJECTSURVEYDETAILS_QUESTIONANSWER: 'ProjectSurveyDetails/AddUpdateProjectSurveyDetails'
    },
    BULKDATAPROCESSING: {
        TRIGGER_BULK_DATA_PROCESSING: 'BulkDataProcessing/TriggerBulkDataProcessing',
        GET_BULK_DATA_PROCESSING_STATUS: 'BulkDataProcessing/GetBulkDataProcessingStatus',
        DOWNLOAD_EXPORTED_DATA: 'BulkDataProcessing/DownloadExportedData',
        PROCESS_EXPENSE_SURVEY_REPORT: 'BulkDataProcessing/ProcessExpenseSurveyReport'
    },
    LEGAL_ENTITY:{
        GET_ENTITIES:'LegalEntity/GetLegalEntities',
        ADD_ENTITIES:'LegalEntity/AddLegalEntity',
        EDIT_ENTITY:'LegalEntity/UpdateLegalEntity',
        DELETE_ENTITY:'LegalEntity/DeleteLegalEntities'
    }
};
